import countries from 'constants/countries';

const COUNTRIES = countries.reduce((all, country) => {
  all[country.isoCode] = country.name;
  return all;
}, {});

export default COUNTRIES;
